import React from "react";
import { Logo } from "../../components/Logo/Logo";
import { contact_info } from "../../constants/contact";
import "./Footer.css";

export const FooterModule: React.FC = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="footer">
      <div className="footer__container">
        <div className="footer__main">
          <div className="footer__brand">
            <Logo variant="light" size="medium" className="footer__logo" />
            <p className="footer__tagline">Managed Hosting</p>
            <p className="footer__description">
              Canadian-run managed hosting company focused on reliability.
            </p>
          </div>

          <div className="footer__contact">
            <div>
              <h3 className="footer__section-title">Contact</h3>
              <ul className="footer__list">
                <li>
                  <a
                    className="footer__link"
                    href={`mailto:${contact_info.email}`}
                  >
                    {contact_info.email}
                  </a>
                </li>
                <li>
                  <a
                    className="footer__link"
                    href={`tel:${contact_info.phone_link}`}
                  >
                    {contact_info.phone_display}
                  </a>
                </li>
                <li className="footer__text">{contact_info.location}</li>
              </ul>
            </div>
            <div>
              <h3 className="footer__section-title">Explore</h3>
              <ul className="footer__list">
                <li>
                  <a className="footer__link" href="#offerings">
                    Hosting
                  </a>
                </li>
                <li>
                  <a className="footer__link" href="#contact">
                    Get in touch
                  </a>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <div className="footer__bottom">
          <p className="footer__copyright">
            © {currentYear} FancyCloud. All rights reserved.
          </p>
          <div className="footer__note">
            Reliability-first hosting from our datacentre
            <span className="footer__maple" aria-hidden="true">🍁</span>
          </div>
        </div>
      </div>
    </footer>
  );
};

// Register the module
export default {
  id: "footer",
  name: "Footer",
  component: FooterModule,
  priority: 100,
  render: () => <FooterModule />,
};
